import { FieldTypes } from '../../../constants/FieldTypes'
import {
  DropdownField,
  DropdownOptionItem,
  Field,
  FieldMap,
  InfoStage,
} from '../../../types/forms/fields'

export const notPregnantNote: InfoStage = {
  info: true,
  name: 'Notice',
  condition: v => v?.option === 'not-pregnant' && v?.notPregnantOption === 'current-plan',
  data: [
    {
      type: 'span',
      children: [
        {
          text: `Hamilton Billing is happy to provide you with an assessment, however, please be aware that we only provide one free assessment per pregnancy. We recommend patients circle back with us when they are pregnant.

If you would like to receive an assessment, please complete the "Primary Coverage" section with your current plan`,
        },
      ],
    },
  ],
}

export type NotPregnantOption = 'current-plan' | 'other-options' | 'no-coverage'

export const notPregnantOptions: DropdownOptionItem<NotPregnantOption>[] = [
  {
    text: 'I have insurance coverage and would like an assessment on my current plan',
    id: 'current-plan',
  },
  {
    text: 'I have insurance coverage but would like to see information on coverage options',
    id: 'other-options',
  },
  {
    text: 'I do not have insurance coverage and would like to see information on potential plans',
    id: 'no-coverage',
  },
]

export const notPregnantOptionField: DropdownField = {
  type: FieldTypes.DROPDOWN,
  placeholder: 'Please specify...',
  options: notPregnantOptions,
  condition: v => v?.option === 'not-pregnant',
}

export const notPregnantFields: Record<string, Field | InfoStage> = {
  notPregnantOption: notPregnantOptionField,
  notPregnantNote,
}

export const notPregnantField: FieldMap = {
  name: '',
  children: notPregnantFields,
  condition: v => v?.option === 'not-pregnant',
}
